import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionSummary } from "@mui/material";
import Accordion, { AccordionProps } from "@mui/material/Accordion";
import { ReactNode, useEffect, useState } from "react";
import CloseIcon from "../../../assets/images/icons/CloseIcon";

type BriaAccordionProps = {
	accordionTitle: ReactNode;
	titleClass?: string;
	primaryButton?: ReactNode;
	useSecondaryIcons?: boolean;
} & AccordionProps;

const BriaAccordion = ({
	accordionTitle,
	titleClass,
	useSecondaryIcons = false,
	children,
	expanded,
	...rest
}: BriaAccordionProps) => {
	const [localExpanded, setLocalExpanded] = useState(expanded);

	useEffect(() => {
		setLocalExpanded(expanded);
	}, [expanded]);

	const getExpandIcon = () => {
		if (useSecondaryIcons) {
			return localExpanded ? <CloseIcon /> : <AddIcon />;
		}
		return <ExpandMoreIcon />;
	};

	return (
		<Accordion
			{...rest}
			disableGutters
			elevation={0}
			square
			expanded={localExpanded}
			onChange={() => setLocalExpanded(!localExpanded)}
		>
			<AccordionSummary className={titleClass} expandIcon={getExpandIcon()}>
				{accordionTitle}
			</AccordionSummary>
			{children}
		</Accordion>
	);
};

export default BriaAccordion;
